var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.7,
    d: "M16.3134 16.6903C20.0311 16.6903 23.0448 13.6766 23.0448 9.95893C23.0448 6.24129 20.0311 3.22754 16.3134 3.22754C12.5958 3.22754 9.58203 6.24129 9.58203 9.95893C9.58203 13.6766 12.5958 16.6903 16.3134 16.6903Z",
    fill: "#8f9bba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3119 20.0562C9.56703 20.0562 4.07422 24.5796 4.07422 30.1532C4.07422 30.5302 4.3704 30.8264 4.74736 30.8264H27.8764C28.2534 30.8264 28.5495 30.5302 28.5495 30.1532C28.5495 24.5796 23.0567 20.0562 16.3119 20.0562Z",
    fill: "#8f9bba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.593c9dc6ba00cedb72785c91feb456f9.svg";
export { ForwardRef as ReactComponent };